export function normalizeArrayResponse(data: unknown, keys: readonly string[]): unknown[] {
  if (Array.isArray(data)) return data;
  if (!isRecord(data)) return [];

  for (const key of keys) {
    const list = normalizeArrayResponse(data[key], keys);
    if (list.length > 0) return list;
  }

  return [];
}

export function normalizeObjectResponse(
  data: unknown,
  keys: readonly string[],
  predicate: (value: unknown) => boolean,
): unknown {
  if (!isRecord(data)) return data;

  for (const key of keys) {
    const candidate = data[key];
    if (predicate(candidate)) return candidate;

    const nested = normalizeObjectResponse(candidate, keys, predicate);
    if (predicate(nested)) return nested;
  }

  return data;
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
